<template>
  <div class="start-button-wrap" :style="{ backgroundSize, backgroundPosition }">
    <div class="start-button" @click="start">
      <div class="btn-animate" :class="animate"></div>
      <!-- <img :src="imgs.btn" class="btn" /> -->
      <span class="btn2"></span>
      <div class="btn text">
        <img :src="curStatus.icon" :style="imgStyle" />
        <span :style="textStyle">{{ curStatus.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/components/virtualPhone/data/resource';

export default {
  inject: ['calc'],
  props: {
    status: {
      validator(v) {
        const valid = ['run', 'stop'];
        return valid.includes(v);
      },
      default: 'run'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgs: {
        btn: get('btn'),
        start: get('start'),
        end: get('end')
      }
    };
  },
  computed: {
    backgroundSize() {
      return `${this.calc(658.08, 'px')} ${this.calc(535.68, 'px')}`;
    },
    backgroundPosition() {
      return `-${this.calc(147.6, 'px')} -${this.calc(110.16, 'px')}`;
    },
    imgStyle() {
      return {
        height: this.calc(63.504, 'px')
      };
    },
    textStyle() {
      return {
        fontSize: this.calc(42.336, 'px'),
        lineHeight: this.calc(52.919, 'px')
      };
    },
    curStatus() {
      const text = this.status === 'stop' ? '开始' : '停止';
      const icon = this.status === 'stop' ? this.imgs.start : this.imgs.end;
      return {
        text,
        icon
      };
    },
    animate() {
      return this.status === 'stop' ? 'btn-animate-end' : 'btn-animate-start';
    }
  },
  methods: {
    start() {
      if (this.loading) return;
      this.$emit('switch', this.status === 'stop' ? 'run' : 'stop');
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes animal {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.start-button-wrap {
  width: 50%;
  padding-bottom: 50%;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  background: url('~@/assets/image/virtual-phone/detect/bg.png') no-repeat center;
  overflow: hidden;
  .btn-animate-end {
    background: url('~@/assets/image/virtual-phone/detect/btn-animate-stop.png') no-repeat;
    background-size: contain;
  }
  .btn-animate-start {
    background: url('~@/assets/image/virtual-phone/detect/btn-animate-start.png') no-repeat;
    background-size: contain;
    animation: animal 4s infinite linear;
  }
  .btn-animate {
    width: 100%;
    padding-bottom: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .start-button {
    width: 80%;
    height: 0;
    padding-bottom: 80%;
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transform-origin: center center;
    cursor: pointer;
    .btn {
      width: 80%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      &.text {
        color: #39e5ff;
        display: flex;
        justify-content: center;
        span {
          font-weight: bold;
          margin-left: 4px;
        }
      }
    }
    .btn2 {
      box-sizing: border-box;
      width: 80%;
      height: 80%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: conic-gradient(#5d6274, #181b28, #5a5e6f, #1b1f2b, #616578, #424756, #5d6173);
      border: 5px solid #a0a1a2;
      border-radius: 50%;
    }
  }
}
</style>
